import axios from "axios";
import toast from "react-hot-toast";
import store from "../Redux/store";
import { clearUser } from "../Redux/userActions";

const getCookie = (name) => {
  if (typeof document === "undefined") return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

const axiosInstance = axios.create({
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = store.getState()?.user?.token || getCookie("token");
    if (token) {
      if (config.headers?.set) {
        config.headers.set("Authorization", `Bearer ${token}`);
      } else {
        if (!config.headers) config.headers = {};
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      if (window.location.pathname !== "/login") {
        sessionStorage.setItem("redirectAfterLogin", window.location.pathname);
      }
      toast.error("Session expired. Please log in again.");
      store.dispatch(clearUser());
      window.location.href = "/login";
      return Promise.reject(error);
    }

    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.error ||
      error?.message ||
      "Something went wrong";

    toast.error(message);

    return Promise.reject(error);
  },
);

export default axiosInstance;
